


















import {Component, Prop, Vue} from 'vue-property-decorator';
import {ActiveInject} from "@/support/reactive"

/**
 * @status stable
 * @published $next
 * @changelog $next Published.
 * @changelog 6.8.4 Removed flex from base element.
 */
@Component
export default class JdsSelectFieldOption extends Vue {
    @ActiveInject({from: 'jds.select-field.bus'}) bus!: Vue
    @ActiveInject({from: 'jds.select-field.value'}) currentValue!: string
    @ActiveInject({from: 'jds.select-field.portal'}) portalTarget!: string
    @Prop() value!: string

    get isActive() {
        return JSON.stringify(this.value) === JSON.stringify(this.currentValue)
    }



    emitSelection() {
        if (this.bus) {
            this.bus.$emit('input', this.value)
        }
    }
}
